import React, { useState, useEffect } from "react";
import { ReactComponent as IconCall } from "assets/icons/chatbot_Llamar.svg";
import { ReactComponent as IconWhatsapp } from "assets/icons/chatbot_Whatsapp.svg";
import { ReactComponent as IconCorreo } from "assets/icons/chatbot_Correo.svg";
import { ReactComponent as IconPQRS } from "assets/icons/chatbot_PQRS.svg";
import Chatbot  from "assets/icons/Chatbot.svg";

import "styles/robot/menu-robot.css";
import { NavLink } from "react-router-dom";

const MenuRobot = () => {
  const [showIcons, setShowIcons] = useState(false);
  const [iconsVisible, setIconsVisible] = useState([
    false,
    false,
    false,
    false,
  ]);

  const toggleIcons = () => {
    setShowIcons(!showIcons);
  };

  useEffect(() => {
    if (showIcons) {
      const timeouts = [];
      for (let i = 0; i < iconsVisible.length; i++) {
        timeouts.push(
          setTimeout(() => {
            setIconsVisible((prev) => {
              const newIconsVisible = [...prev];
              newIconsVisible[i] = true;
              return newIconsVisible;
            });
          }, i * 200),
        );
      }

      return () => {
        timeouts.forEach((timeout) => clearTimeout(timeout));
      };
    } else {
      setIconsVisible([false, false, false, false,]);
    }
  }, [showIcons, iconsVisible.length]);
  

  return (
    <div className="robot-float">
      <div
        className={`${showIcons ? "border-menu" : ""}`}
        onClick={toggleIcons}
      >
        <div onClick={toggleIcons} className="icon-robot">
          <img src={Chatbot} alt="menu elite vacances" className="image-menu" />
          {/* <Chatbot /> */}
        </div>
      </div>

      <div className={`icons-container ${showIcons ? "show" : ""}`}>
        {/* <NavLink
          to="/questions"
          className={`icon-item ${iconsVisible[0] ? "visible" : ""}`}
          data-tooltip="Preguntas Frecuentes"
        >
          <IconAsk />
        </NavLink> */}
        <a
          href="tel:+5717945996"
          className={`icon-item ${iconsVisible[0] ? "visible" : ""}`}
          data-tooltip="Llamar"
          rel="noopener noreferrer"
        >
          <IconCall />
        </a>
        <a
          href="https://api.whatsapp.com/send?phone=5717945996"
          target="_blank"
          className={`icon-item ${iconsVisible[1] ? "visible" : ""}`}
          data-tooltip="WhatsApp"
          rel="noopener noreferrer"
        >
          <IconWhatsapp />
        </a>
        <a
          href="mailto:sac@elitevacances.com"
          className={`icon-item ${iconsVisible[2] ? "visible" : ""}`}
          data-tooltip="Correo"
        >
          <IconCorreo />
        </a>
        <NavLink
          to="pqrs"
          className={`icon-item ${iconsVisible[3] ? "visible" : ""}`}
          data-tooltip="PQRS"
        >
          <IconPQRS />
        </NavLink>
      </div>
    </div>
  );
};

export default MenuRobot;
